// export const androidAppLink = "https://play.google.com/store/apps/details?id=com.facebook.katana"
export const iosAppLink = "https://apps.apple.com/fr/app/guardwatch-pro/id6444667377?l=en"
export const androidAppLink = "https://play.google.com/store/apps/details?id=com.prodeos.guardwatch.pro&hl=en"